export default __webpack_public_path__ + "static/media/cologs.7ce94a4c.png";